import _createForOfIteratorHelper from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _toConsumableArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, OverlayTrigger, Tooltip, Popover } from 'react-bootstrap';
import { Col, Row, Container, Card } from 'react-bootstrap';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import StepIcon from '@mui/material/StepIcon';
import Stepper from '@mui/material/Stepper';
import { Cleaner } from './components/Cleaner';
import { Dropper } from './components/Dropper';
import { Visualizer, SHAPER_SIMPLE } from './components/Visualizer';
import { Sharer } from './components/Sharer';
import { Algorithms } from './components/Algorithms';
import { Layout } from './components/Layout';
import { PREVIEW_STATUS_INFO, PREVIEW_STATUS_WARN, PREVIEW_STATUS_ERROR, Preview } from './components/Preview';
import { inferEdgeFileTable, inferHyperedges } from './components/inference';
import { useDebounce } from './utils/useDebounce';
//import { validateEdgeSchemaTypeMatch, validateNodeSchemaTypeMatch } from './validate';

import { WelcomeBar } from './components/WelcomeBar';
import mainStyles from './styles/main-panel.less';
import styles from './styles/file-uploader.less';
import { GraphistryWebVisualizer } from './components/GraphistryWebVisualizer';
import { bindingsReady } from './components/bindings';
var UPLOAD_BASE_PATH = '';
//const UPLOAD_BASE_PATH = 'http://localhost';

import logger from './utils/logger';
var log = logger.createLogger('FileUploader');
import { FAKE_FILES } from './components/debug';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IS_DEBUG = false; //true;

var steps = ['Upload', 'Check', 'Shape', 'Algorithms', 'Layout', 'Share'];
var DEFAULT_IS_AUTO_PREVIEW = !IS_DEBUG;
function totalSteps() {
  return steps.length;
}
;
function completedSteps(completed) {
  return Object.keys(completed).length;
}
;
function isLastStep(activeStep) {
  return activeStep === totalSteps() - 1;
}
;
function allStepsCompleted(completed) {
  return completedSteps(completed) === totalSteps();
}
;
function handleNext(activeStep, completed, setActiveStep) {
  var newActiveStep = isLastStep(activeStep) && !allStepsCompleted(completed) ?
  // It's the last step, but not all steps have been completed,
  // find the first step that has been completed
  steps.findIndex(function (step, i) {
    return !(i in completed);
  }) : activeStep + 1;
  setActiveStep(function () {
    return newActiveStep;
  });
}
;
function handleBack(setActiveStep) {
  setActiveStep(function (activeStep) {
    return activeStep - 1;
  });
}
;
function handleStep(setActiveStep, step) {
  setActiveStep(function () {
    return step;
  });
}
function updateViz(_ref) {
  var vizUploader = _ref.vizUploader,
    visualization = _ref.visualization,
    setVisualization = _ref.setVisualization,
    files = _ref.files,
    user = _ref.user,
    visualizationBindings = _ref.visualizationBindings,
    setPreviewStatus = _ref.setPreviewStatus;
  log.debug({
    visualizationBindings: visualizationBindings
  }, '@updateViz');
  if (visualization.dataset_id) {
    setPreviewStatus(function () {
      return {
        status: PREVIEW_STATUS_WARN,
        message: 'Deleting previous visualization'
      };
    });
  }
  var _bindingsReady = bindingsReady({
      files: files,
      visualizationBindings: visualizationBindings
    }),
    isReady = _bindingsReady.isReady,
    hasEdges = _bindingsReady.hasEdges,
    hasNodes = _bindingsReady.hasNodes;
  if (!hasEdges) {
    var msg = "Visualization requires an edge file and bindings, even if no entries";
    setPreviewStatus(function () {
      return {
        status: PREVIEW_STATUS_ERROR,
        message: msg
      };
    });
    throw new Error(msg);
  }
  var base = visualization.dataset_id ? vizUploader.deleteVisualization({
    dataset_id: visualization.dataset_id
  }).then(function () {
    return null;
  }) //mask success status message
  .catch(function (err) {
    log.error({
      err: err
    }, 'Failed delete of old visualization, but proceed with new create anyways');
    return err;
    //TODO pop a JUI warning?
  }) : new Promise(function (resolve) {
    return resolve(true);
  });
  return base.then(function (deleteStatus) {
    setPreviewStatus(function () {
      return deleteStatus ? {
        status: PREVIEW_STATUS_WARN,
        message: "Error deleting previous visualization, but proceeding anyways. Error: ".concat(deleteStatus)
      } : visualizationBindings.dataset_id ? {
        status: PREVIEW_STATUS_INFO,
        message: "Deleted previous visualization, creating new one"
      } : {
        status: PREVIEW_STATUS_INFO,
        message: "Creating visualization..."
      };
    });
    var edgeBindings = visualizationBindings.shaper.simple.hyperedges && visualizationBindings.shaper.simple.hyperedges.direct ? {
      'source': 'src',
      'destination': 'dst'
    } : visualizationBindings.shaper.simple.hyperedges ? {
      'source': 'EventID',
      'destination': 'attribID'
    } : hasEdges ? {
      'source': visualizationBindings.shaper.simple.edges.src,
      'destination': visualizationBindings.shaper.simple.edges.dst
    } : null;
    var edgeFiles = hasEdges ? [[files[visualizationBindings.shaper.simple.edges.fileIndex].file_id, visualizationBindings.shaper.simple.edges.tableIndex]] : null;
    var nodeBindings = hasNodes ? {
      'node': visualizationBindings.shaper.simple.nodes.node
    } : visualizationBindings.shaper.simple.hyperedges ? {
      'node': 'nodeID'
    } : {};
    var nodeFiles = hasNodes ? [[files[visualizationBindings.shaper.simple.nodes.fileIndex].file_id, visualizationBindings.shaper.simple.nodes.tableIndex]] : null;
    log.info({
      he: visualizationBindings.shaper.simple.hyperedges
    }, 'hyperedges');
    var edgeHypergraphTransform = [{
      direct: !!visualizationBindings.shaper.simple.hyperedges.direct,
      entity_types: visualizationBindings.shaper.simple.hyperedges.entity_types || {},
      opts: _objectSpread({}, visualizationBindings.shaper.simple.hyperedges.opts || {}),
      drop_na: visualizationBindings.shaper.simple.hyperedges.dropNA,
      drop_edge_attrs: visualizationBindings.shaper.simple.hyperedges.dropEdgeAttrs
    }];
    if (visualizationBindings.shaper.simple.hyperedges.mergeAllCategories) {
      if (hasEdges && edgeFiles && visualizationBindings.shaper.simple.edges.tableIndex != null && visualizationBindings.shaper.simple.edges.tableIndex != undefined) {
        edgeHypergraphTransform[0].opts.CATEGORIES = {
          'n': visualizationBindings.shaper.simple.hyperedges.entity_types || Object.keys(files[visualizationBindings.shaper.simple.edges.fileIndex].fileStats.tables_schemas[visualizationBindings.shaper.simple.edges.tableIndex])
        };
        //simple graphs look better without hypergraphs
        if (edgeHypergraphTransform[0].opts.CATEGORIES.n.length == 2) {
          edgeBindings.source = edgeHypergraphTransform[0].opts.CATEGORIES.n[0];
          edgeBindings.destination = edgeHypergraphTransform[0].opts.CATEGORIES.n[1];
          edgeHypergraphTransform = null;
          if (hasNodes) {
            nodeBindings = {
              'node': visualizationBindings.shaper.simple.nodes.node
            };
          } else {
            nodeBindings = {};
          }
        } else {
          nodeBindings.node_title = 'nodeTitle';
        }
      }
    }
    setPreviewStatus(function () {
      return {
        status: PREVIEW_STATUS_INFO,
        message: 'Creating visualization from files'
      };
    });
    var metadata = _objectSpread({}, visualizationBindings.logoUrl ? {
      logo: {
        url: visualizationBindings.logoUrl
      }
    } : {});
    var compute = (visualizationBindings.remote || {}).compute || {};
    var layout = (visualizationBindings.remote || {}).layout || {};
    return vizUploader.createVisualization(_objectSpread(_objectSpread({
      name: visualizationBindings.name,
      description: visualizationBindings.description,
      nodeEncodings: {
        bindings: nodeBindings
      },
      nodeFiles: nodeFiles,
      edgeEncodings: {
        bindings: edgeBindings
      },
      edgeFiles: edgeFiles
    }, edgeHypergraphTransform ? {
      edgeHypergraphTransform: edgeHypergraphTransform
    } : {}), {}, {
      compute: compute,
      layout: layout,
      metadata: metadata,
      user: user
    }));
  }).then(function (out) {
    //TODO store output dataset_id for viz?
    log.debug({
      out: out
    }, 'created visualization!');
    var dataset_id = out.dataset_id;
    setPreviewStatus(function () {
      log.debug({
        dataset_id: dataset_id
      }, 'Clearing preview status (dataset created)');
      return null;
    });
    setVisualization(function () {
      log.debug({
        dataset_id: dataset_id
      }, 'Set visualization!');
      return {
        dataset_id: dataset_id
      };
    });
    return {
      dataset_id: dataset_id
    };
  }).catch(function (exn) {
    log.error({
      exn: exn
    }, 'create viz exn');
    setPreviewStatus(function () {
      return {
        status: PREVIEW_STATUS_ERROR,
        message: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("h3", {
            children: "Error updating visualization"
          }), exn.toString() || 'Unknown error creating visualization from files and bindings']
        })
      };
    });

    //throw exn;
  });
}

//See: https://material-ui.com/components/steppers/
export function FileUploader(props) {
  var _this = this;
  var user = props;
  log.debug({
    user: user
  }, 'FileUploader');

  //const {id, name, value} = props;

  //int
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    activeStep = _useState2[0],
    setActiveStep = _useState2[1];

  //{'a -> bool}
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 1),
    completed /*, setCompleted */ = _useState4[0];

  //[ {
  //      reason: str,  status: STATUS,
  //      name: str, size: bytes,
  //      file_id: str,
  //      compressStartedMS, compressFinishedMS, compressedBytes, sizeCompressedBytes,
  //      uploadStartedMS, uploadFinishedMS, uploadedBytes, sizeCompressedBytes,
  //      fileStats: { file_id, name, description,  tables_schemas[]: { name, num_rows, num_cols, dtypes: { str -> str }} },
  //      error
  //  } ]
  var _useState5 = useState(!IS_DEBUG ? [] : FAKE_FILES),
    _useState6 = _slicedToArray(_useState5, 2),
    files = _useState6[0],
    setFiles = _useState6[1];
  if (IS_DEBUG) {
    console.debug('FAKE_FILES', {
      FAKE_FILES: FAKE_FILES
    });
  }
  var _useState7 = useState(new GraphistryWebVisualizer({}, {
      csrfToken: user.csrfToken,
      csrfmiddlewaretoken: user.csrfmiddlewaretoken,
      activeOrganization: user.activeOrganization,
      username: user.username
    }, UPLOAD_BASE_PATH)),
    _useState8 = _slicedToArray(_useState7, 2),
    vizUploader = _useState8[0],
    setVizUploader = _useState8[1];

  //{ }
  var _useState9 = useState({
      name: 'Untitled',
      description: '',
      layout: SHAPER_SIMPLE,
      logoUrl: null,
      remote: {
        compute: {},
        layout: {}
      },
      nodeEncodings: {
        bindings: {}
      },
      edgeEncodings: {
        bindings: {}
      },
      urlSettings: {
        play: 5000
      },
      shaper: {
        simple: {
          enabled: true,
          edges: {
            enabled: true,
            fileIndex: null,
            tableIndex: null,
            src: null,
            dst: null,
            attributes: null
          },
          hyperedges: {
            //allToAll: false (prevent EDGES, but do use entity_typess)
            //direct: true,
            //entity_types: ['x', 'y']
            //opts: {'EDGES': {'x': ['y']}, 'CATEGORIES': {'a': ['b']}}
            //categories: {int: v} //in case name conflicts during data entry (!)
            dropNA: true,
            dropEdgeAttrs: false,
            mergeAllCategories: true
          },
          nodes: IS_DEBUG ? {
            enabled: true,
            fileIndex: 0,
            tableIndex: 0,
            node: 'ip',
            attributes: ['a', 'c']
          } : {
            enabled: false,
            fileIndex: null,
            tableIndex: null,
            node: null,
            attributes: null
          }
        }
      }
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    visualizationBindings = _useState10[0],
    setVisualizationBindings = _useState10[1];
  var visualizationBindingsDebounced = useDebounce(visualizationBindings, 3000);
  var _useState11 = useState('fa2'),
    _useState12 = _slicedToArray(_useState11, 2),
    layout = _useState12[0],
    setLayout = _useState12[1];
  var _useState13 = useState(DEFAULT_IS_AUTO_PREVIEW),
    _useState14 = _slicedToArray(_useState13, 2),
    autoPreview = _useState14[0],
    setAutoPreview = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    previewStatus = _useState16[0],
    setPreviewStatus = _useState16[1]; // {status: 'info' | 'warn' | 'error', message: str} || null

  //{ dataset_id, success, out, error }
  var _useState17 = useState(!IS_DEBUG ? {} : {
      'dataset_id': 'Miserables'
    }),
    _useState18 = _slicedToArray(_useState17, 2),
    visualization = _useState18[0],
    setVisualization = _useState18[1];
  var classes = {
    button: {}
  };
  log.debug({
    props: props,
    hooks: {
      activeStep: activeStep,
      completed: completed,
      files: files,
      visualizationBindings: visualizationBindings
    }
  }, 'FileUploader');
  function triggerVizUpdate(liveness) {
    log.debug({
      liveness: liveness
    }, '@triggerVizUpdate');
    updateViz({
      vizUploader: vizUploader,
      visualization: visualization,
      setVisualization: setVisualization,
      files: files,
      user: user,
      visualizationBindings: visualizationBindings,
      setPreviewStatus: setPreviewStatus
    });
  }

  //Try to infer & set edge file/table
  useEffect(function () {
    if (files && files.length && visualizationBindings.shaper.simple && (visualizationBindings.shaper.simple.edges.fileIndex === undefined || visualizationBindings.shaper.simple.edges.fileIndex === null) && (visualizationBindings.shaper.simple.edges.tableIndex === undefined || visualizationBindings.shaper.simple.edges.tableIndex === null)) {
      var _inferEdgeFileTable = inferEdgeFileTable({
          files: files,
          fileIndex: visualizationBindings.shaper.simple.edges.fileIndex,
          tableIndex: visualizationBindings.shaper.simple.edges.tableIndex
        }),
        fileIndex = _inferEdgeFileTable.fileIndex,
        tableIndex = _inferEdgeFileTable.tableIndex;
      if (fileIndex != undefined && fileIndex != null && tableIndex != undefined && tableIndex != null && (fileIndex != visualizationBindings.shaper.simple.edges.fileIndex || tableIndex != visualizationBindings.shaper.simple.edges.tableIndex)) {
        setVisualizationBindings(function (before) {
          return _objectSpread(_objectSpread({}, before), {}, {
            shaper: _objectSpread(_objectSpread({}, before.shaper), {}, {
              simple: _objectSpread(_objectSpread({}, before.shaper.simple), {}, {
                edges: _objectSpread(_objectSpread({}, before.shaper.simple.edges), {}, {
                  fileIndex: fileIndex,
                  tableIndex: tableIndex
                })
              })
            })
          });
        });
      }
    }
  }, [files, visualizationBindings]);

  //Infer hyperedge when file/table change + old settings no longer applying
  useEffect(function () {
    if ((visualizationBindings.shaper.simple.hyperedges.fileIndex != visualizationBindings.shaper.simple.edges.fileIndex || visualizationBindings.shaper.simple.hyperedges.tableIndex != visualizationBindings.shaper.simple.edges.tableIndex) && visualizationBindings.shaper.simple.edges.fileIndex != null && visualizationBindings.shaper.simple.edges.fileIndex != undefined && visualizationBindings.shaper.simple.edges.tableIndex != null && visualizationBindings.shaper.simple.edges.tableIndex != undefined) {
      var fileStats = files[visualizationBindings.shaper.simple.edges.fileIndex].fileStats;
      var tableObj = fileStats.tables_schemas[visualizationBindings.shaper.simple.edges.tableIndex];
      if (!tableObj || !tableObj.dtypes) {
        return;
      }
      var edges = (visualizationBindings.shaper.simple.hyperedges.opts || {}).EDGES;
      var srcs = Object.keys(edges || {});
      var dsts = [];
      for (var _i = 0, _Object$values = Object.values(edges || {}); _i < _Object$values.length; _i++) {
        var v = _Object$values[_i];
        dsts = dsts.concat(v);
      }
      var all = _toConsumableArray(new Array(srcs.concat(dsts)));
      var valid = true;
      var _iterator = _createForOfIteratorHelper(all),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var fld = _step.value;
          if (!(fld in tableObj.dtypes)) {
            valid = false;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (valid) {
        log.info({
          all: all,
          tableObj: tableObj
        }, 'still valid, no need to re-infer bindings');
        return;
      }
      var hyperedges = inferHyperedges(tableObj);
      setVisualizationBindings(function (before) {
        return _objectSpread(_objectSpread({}, before), {}, {
          shaper: _objectSpread(_objectSpread({}, before.shaper), {}, {
            simple: _objectSpread(_objectSpread({}, before.shaper.simple), {}, {
              hyperedges: _objectSpread(_objectSpread(_objectSpread({}, visualizationBindings.shaper.simple.hyperedges), hyperedges), {}, {
                fileIndex: visualizationBindings.shaper.simple.edges.fileIndex,
                tableIndex: visualizationBindings.shaper.simple.edges.tableIndex,
                opts: _objectSpread(_objectSpread({}, visualizationBindings.shaper.simple.hyperedges.opts || {}), hyperedges.opts || {})
              })
            })
          })
        });
      });
    }
  }, [files, visualizationBindings]);

  //Update viz on change
  useEffect(function () {
    log.debug({
      visualizationBindings: visualizationBindings,
      autoPreview: autoPreview
    }, '@previewEffect');
    var liveness = {
      live: true
    };
    if (autoPreview) {
      var _bindingsReady2 = bindingsReady({
          files: files,
          visualizationBindings: visualizationBindings
        }),
        isReady = _bindingsReady2.isReady,
        message = _bindingsReady2.message;
      if (isReady) {
        log.debug({
          visualizationBindings: visualizationBindings
        }, 'previewEffect: viz auto triggered!');
        if (visualizationBindings == visualizationBindingsDebounced) {
          log.debug('Debounced viz bindings update, kicking off upload');
          triggerVizUpdate(liveness);
        }
      } else {
        log.debug({
          message: message
        }, 'previewEffect: In preview mode, but changes are not yet valid..');
      }
    } else {
      log.debug('previewEffect: no autoPreview');
    }
    return function () {
      log.debug('preview cleanup..');
      liveness.live = false;
      //cleanup
    };
  }, [visualizationBindings, visualizationBindingsDebounced, autoPreview]);
  var stepper = /*#__PURE__*/_jsx(Stepper, {
    nonLinear: true,
    activeStep: activeStep,
    children: steps.map(function (label, index) {
      return /*#__PURE__*/_jsx(Step, {
        children: /*#__PURE__*/_jsx(StepButton, {
          onClick: handleStep.bind(_this, setActiveStep, index),
          completed: completed[index],
          children: label
        })
      }, label);
    })
  });
  function BackButton(_ref2) {
    var big = _ref2.big;
    return /*#__PURE__*/_jsxs(Button, {
      disabled: activeStep === 0,
      onClick: handleBack.bind(this, setActiveStep),
      className: classes.button,
      children: [/*#__PURE__*/_jsx("i", {
        className: "fa fa-caret-left"
      }), big ? ' Back ' : null]
    });
  }
  function NextButton(_ref3) {
    var big = _ref3.big,
      className = _ref3.className;
    return /*#__PURE__*/_jsxs(Button, {
      disabled: activeStep === steps.length - 1,
      variant: "contained",
      color: "primary",
      onClick: handleNext.bind(this, activeStep, completed, setActiveStep),
      className: "".concat(classes.button, " ").concat(className),
      children: [big ? ' Next ' : null, /*#__PURE__*/_jsx("i", {
        className: "fa fa-caret-right"
      })]
    });
  }
  var buttons = /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(BackButton, {}), /*#__PURE__*/_jsx(NextButton, {})]
  });
  return /*#__PURE__*/_jsxs(Card, {
    className: mainStyles['main-panel-panel'],
    children: [/*#__PURE__*/_jsx(WelcomeBar, {
      stepper: stepper,
      buttons: buttons
    }), /*#__PURE__*/_jsxs(Card, {
      className: mainStyles.panel,
      children: [/*#__PURE__*/_jsxs(Card.Header, {
        children: [/*#__PURE__*/_jsx("span", {
          className: styles['step-header-icon'],
          children: /*#__PURE__*/_jsx(StepIcon, {
            active: true,
            icon: activeStep + 1
          })
        }), steps[activeStep]]
      }), /*#__PURE__*/_jsxs(Card.Body, {
        children: [/*#__PURE__*/_jsx(Dropper, {
          visible: activeStep == 0,
          user: user,
          files: files,
          setFiles: setFiles
        }), /*#__PURE__*/_jsx(Cleaner, {
          visible: activeStep == 1,
          user: user,
          files: files,
          setFiles: setFiles
        }), /*#__PURE__*/_jsx(Visualizer, {
          visible: activeStep == 2,
          user: user,
          files: files,
          visualizationBindings: visualizationBindings,
          setVisualizationBindings: setVisualizationBindings
        }), /*#__PURE__*/_jsx(Algorithms, {
          visible: activeStep == 3,
          user: user,
          files: files,
          visualization: visualization,
          visualizationBindings: visualizationBindings,
          setVisualizationBindings: setVisualizationBindings,
          layout: layout,
          setLayout: setLayout
        }), /*#__PURE__*/_jsx(Layout, {
          visible: activeStep == 4,
          user: user,
          files: files,
          visualization: visualization,
          visualizationBindings: visualizationBindings,
          setVisualizationBindings: setVisualizationBindings,
          layout: layout,
          setLayout: setLayout
        }), /*#__PURE__*/_jsx(Sharer, {
          visible: activeStep == 5,
          user: user,
          files: files,
          visualization: visualization,
          visualizationBindings: visualizationBindings,
          setVisualizationBindings: setVisualizationBindings
        })]
      })]
    }), /*#__PURE__*/_jsx(Card, {
      className: mainStyles.panel,
      children: /*#__PURE__*/_jsx(Card.Body, {
        className: "bg-white",
        children: /*#__PURE__*/_jsx(Container, {
          children: /*#__PURE__*/_jsxs(Row, {
            children: [/*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx(BackButton, {
                big: true
              })
            }), /*#__PURE__*/_jsx(Col, {}), /*#__PURE__*/_jsx(Col, {
              children: /*#__PURE__*/_jsx(NextButton, {
                big: true,
                className: "pull-right"
              })
            })]
          })
        })
      })
    }), /*#__PURE__*/_jsx(Preview, {
      files: files,
      visualizationBindings: visualizationBindings,
      visualizationBindingsDebounced: visualizationBindingsDebounced,
      visualization: visualization,
      previewStatus: previewStatus,
      setPreviewStatus: setPreviewStatus,
      triggerVizUpdate: triggerVizUpdate,
      autoPreview: autoPreview,
      setAutoPreview: setAutoPreview
    })]
  });
}
FileUploader.propTypes = {
  csrfToken: PropTypes.string,
  csrfmiddlewaretoken: PropTypes.string,
  activeOrganization: PropTypes.string,
  username: PropTypes.string,
  entitlements: PropTypes.object
};
export default FileUploader;